import { ChangeEvent, useRef } from 'react'
import { Form, useFormikContext } from 'formik'
import { Button, IconButton, Link, Typography } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import ClearIcon from '@mui/icons-material/Clear'

import { ICreateStylesForm } from 'src/types'
import { LinkIcon } from 'src/assets/icons'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const StyleCreateForm = () => {
  const inputRef = useRef<HTMLInputElement>(null)
  const classes = useStyles()
  const { errors, isSubmitting, dirty, setFieldValue, values } =
    useFormikContext<ICreateStylesForm>()

  const handleUploadClick = () => {
    inputRef.current?.click()
  }

  const handleUploadChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFieldValue('file', e.target.files[0])
    }
  }

  const handleFileClearClick = () => {
    setFieldValue('file', null)
    inputRef.current?.value && (inputRef.current.value = '')
  }

  const handleLinkClearClick = () => {
    setFieldValue('custom_css', null)
  }

  return (
    <Form className={classes.form}>
      <div className={classes.uploadWrapper}>
        <Button variant="outlined" endIcon={<CloudUploadIcon />} onClick={handleUploadClick}>
          <HelperWrapper t="styles-form-upload-button" />
        </Button>
        {values.file?.name && (
          <div className={classes.styleLink}>
            <Typography className={classes.filename}>{values.file?.name}</Typography>
            <IconButton size="small" onClick={handleFileClearClick}>
              <ClearIcon />
            </IconButton>
          </div>
        )}
        {!values.file?.name && values?.custom_css && (
          <div className={classes.styleLink}>
            <Link
              className={classes.styleLink}
              href={values.custom_css}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={classes.filename}>{values.custom_css}</span>
              <LinkIcon />
            </Link>
            <IconButton size="small" onClick={handleLinkClearClick}>
              <ClearIcon />
            </IconButton>
          </div>
        )}
      </div>
      <input
        hidden
        type="file"
        accept=".css"
        ref={inputRef}
        name="css"
        onChange={handleUploadChange}
      />
      <div className={classes.submitWrapper}>
        <Button
          type="submit"
          variant="contained"
          disabled={isSubmitting || Object.keys(errors).length > 0 || !dirty}
        >
          <HelperWrapper t="styles-form-submit" />
        </Button>
      </div>
    </Form>
  )
}
